import { isPromise } from "~/tools/is-promise";
import type { Result } from "~/tools/result";

export function tryCatch<TValue>(promise: Promise<TValue>): Promise<Result<unknown, TValue>>;
export function tryCatch<TError, TValue>(
	toError: (error: unknown) => TError,
	promise: Promise<TValue>,
): Promise<Result<TError, TValue>>;

export function tryCatch<TValue>(fn: () => Promise<TValue>): Promise<Result<unknown, TValue>>;
export function tryCatch<TError, TValue>(
	toError: (error: unknown) => TError,
	fn: () => Promise<TValue>,
): Promise<Result<TError, TValue>>;

export function tryCatch<TValue>(fn: () => TValue): Result<unknown, TValue>;
export function tryCatch<TError, TValue>(toError: (error: unknown) => TError, fn: () => TValue): Result<TError, TValue>;

export function tryCatch<TError, TValue>(
	...args:
		| [fnOrPromise: (() => TValue | Promise<TValue>) | Promise<TValue>]
		| [toError: (error: unknown) => TError, fnOrPromise: (() => TValue | Promise<TValue>) | Promise<TValue>]
): Result<TError, TValue> | Promise<Result<TError, TValue>> {
	const [toError, fnOrPromise] = args.length === 1 ? [(error: unknown) => error as TError, args[0]] : args;

	try {
		const result = isPromise(fnOrPromise) ? fnOrPromise : fnOrPromise();

		if (isPromise(result)) {
			return result.then(
				(data) => [null, data] as Result<TError, TValue>,
				(error) => [toError(error), null] as Result<TError, TValue>,
			);
		}

		return [null, result];
	} catch (error) {
		return [toError(error), null] as Result<TError, TValue>;
	}
}
